import { useAtomValue } from "jotai";
import { useTranslation } from "react-i18next";
import { Sparkle } from "lucide-react";
import { pageTitleAtom } from "@/stores/atoms/page-title-atom";
import { pageTitleIsAiGeneratedAtom } from "@/stores/atoms/page-title-ai-atom";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

const DynamicPageHeader = () => {
  const { t } = useTranslation();
  const title = useAtomValue(pageTitleAtom);
  const isAiGenerated = useAtomValue(pageTitleIsAiGeneratedAtom);

  if (!title) return null;

  return (
    <div className="flex-1 flex items-center justify-between w-full">
      <h1 className="lg:text-lg text-gray-500 flex items-center gap-1.5">
        {title}
        {isAiGenerated && (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Sparkle size={16} className="text-primary" />
              </TooltipTrigger>
              <TooltipContent>
                {t("modules.dilemmas.ai_generated")}
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        )}
      </h1>
    </div>
  );
};

export default DynamicPageHeader;
